import React, { useState, useEffect } from "react";
import TemplateManagementService from "../services/TemplateManagementService";

const templateService = new TemplateManagementService();

export default function TemplateInventoryView({ rootFileContext, onEdit }) {
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (rootFileContext?.fileName) {
      fetchTemplates();
    }
  }, [rootFileContext]);

  const fetchTemplates = async () => {
    setLoading(true);
    try {
      // Scopes discovery to the specific taxonomy folder
      const list = await templateService.getAllTemplates(rootFileContext);
      setTemplates(list);
    } catch (err) {
      console.error("❌ Inventory Fetch Failed:", err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div className="p-4 text-center small text-muted">Refreshing Template Index...</div>;

  return (
    <div className="table-responsive">
      <table className="table table-hover align-middle mb-0" style={{ fontSize: "12px" }}>
        <thead className="table-light text-muted extra-small text-uppercase">
          <tr>
            <th className="ps-3">Name</th>
            <th>Status</th>
            <th>Last Updated</th>
            <th className="text-end pe-3">Action</th>
          </tr>
        </thead>
        <tbody>
          {templates.length === 0 ? (
            <tr>
              <td colSpan="4" className="text-center p-4 text-muted italic">No templates defined for this version.</td>
            </tr>
          ) : (
            templates.map((t) => (
              <tr key={t.id}>
                <td className="ps-3 fw-bold text-dark">{t.name}</td>
                <td><span className="badge bg-light text-dark border">{t.status}</span></td>
                <td className="text-muted">{new Date(t.updatedAt).toLocaleDateString()}</td>
                <td className="text-end pe-3">
                  <button className="btn btn-xs btn-dark fw-bold" onClick={() => onEdit(t)}>MANAGE</button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}